import React, { useEffect, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import {
  Card,
  Table,
  Row,
  Col,
  CardTitle,
  CardBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
} from 'reactstrap';

import { useLocation, useNavigate } from 'react-router-dom';
import { apiService } from '../../constants/ApiService';
import moment from 'moment';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';

const AddVoucher = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const voucherTypeRef = useRef(null);
  const voucherBankRef = useRef(null);
  const inputRefs = useRef(null);

  const initial = {
    id: null,
    unique_trn_id: null,
    client_purchaser_code: null,
    client_purchaser_name: '',
    agent_code: null,
    agent_name: '',
    vender_code: null,
    vender_name: '',
    vender_master_id: null,
    branch_master_id: null,
    vou_type_id: 1,
    vou_type: 'Receipt',
    vou_fa_year: '',
    vou_ref_no: '',
    vou_date: null,
    vou_cash_bank_id: null,
    vou_cash_bank_name: '',
    tot_vou_amt: 0,
    username: '',
    status: null,
  };

  const initialVoucherTrns = {
    id: null,
    temp_id: null,
    unique_trn_id: null,
    client_purchaser_code: null,
    client_purchaser_name: '',
    agent_code: null,
    agent_name: '',
    vender_code: null,
    vender_name: '',
    voucher_master_id: null,
    vou_p_id: null,
    vou_pname: '',
    vou_chq_detail: '',
    vou_narr: '',
    vou_amt: '',
    vou_agst_bill: '',
    username: '',
    status: 0,
    vou_gst_amt: '',
    vou_gst_per: '',
    vou_gross_amt: '',
    vou_remark: '',
    vou_tax_inc: '',
    vou_tax_type: '',
  };

  const [voucherMasterDetail, setVoucherMasterDetail] = useState(initial);
  const [voucherTanxDetail, setVoucherTanxDetail] =
    useState(initialVoucherTrns);

  const [voucherTransList, setVoucherTransList] = useState([]);

  const [venderMaster, setVenderMasterTable] = useState([]);
  const [branchMaster, setBranchMasterTable] = useState([]);

  const [partyCashTable, setPartyCashTable] = useState([]);
  const [partyWithOutCashTable, setPartyWithOutCashTable] = useState([]);
  const [partyWithOutCashDownTable, setPartyWithOutCashDownTable] = useState(
    [],
  );

  const [voucherList, setVoucherList] = useState([]);
  const [voucherMasterId, setVoucherMasterId] = useState('');

  const [editMode, setEditMode] = useState(false);
  const [voucherTransEditMode, setVoucherTransEditMode] = useState(false);
  const [isSavingTrans, setIsSavingTrans] = useState(false);
  const [isDeletingTrans, setIsDeletingTrans] = useState(false);

  const [voucherMasterError, setVoucherMasterError] = useState({});
  const [voucherTransError, setVoucherTransError] = useState({});
  const [errorMessage, setErrorMessage] = useState({});
  const [systemVoucherData, setSystemVoucherData] = useState('');

  const [pageloading, setPageLoading] = useState({
    vender: true,
    branch: true,
  });

  const getColorForVoucherType = (vouType) => {
    switch (vouType) {
      case 'Payment':
        return '#f4ccd2';
      case 'Contra':
        return '#d3c5e5';
      case 'Journal':
        return '#c4dfe6';
      case 'Receipt':
        return '#cadcfc';
      default:
        return 'inherit';
    }
  };

  const getNumber = (value, defaultValue = 0) => {
    const numberValue = Number(value);
    return Number.isNaN(numberValue) ? defaultValue : numberValue;
  };

  const calculateTotalAmount = (rows) => {
    return (rows || []).reduce(
      (sum, item) => sum + getNumber(item.vou_amt, 0),
      0,
    );
  };

  const resetTransactionForm = () => {
    setVoucherTanxDetail({
      ...initialVoucherTrns,
      voucher_master_id: voucherMasterId || voucherMasterDetail?.id || null,
    });
    setVoucherTransEditMode(false);
    setVoucherTransError({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'vou_type_id') {
      const voucherName = e.target.options[e.target.selectedIndex].text;
      const voucherId = Number(value);
      const selectVoucherName =
        voucherName && voucherName !== 'Select' ? voucherName : '';

      setVoucherMasterDetail((prevState) => ({
        ...prevState,
        vou_type_id: voucherId,
        vou_type: selectVoucherName,
        vou_cash_bank_id: null,
        vou_cash_bank_name: '',
      }));

      setVoucherMasterError((prev) => ({
        ...prev,
        vou_type: '',
      }));

      return;
    }

    if (name === 'vou_date') {
      const selectedDate = new Date(value);
      const selectedMonth = selectedDate.getMonth();

      let startYear;
      let endYear;

      if (selectedMonth < 3) {
        startYear = selectedDate.getFullYear() - 1;
        endYear = selectedDate.getFullYear();
      } else {
        startYear = selectedDate.getFullYear();
        endYear = selectedDate.getFullYear() + 1;
      }

      setVoucherMasterDetail((prevState) => ({
        ...prevState,
        [name]: value,
        vou_fa_year: `${startYear}-${endYear}`,
      }));

      setVoucherMasterError((prev) => ({
        ...prev,
        vou_date: '',
      }));

      return;
    }

    setVoucherMasterDetail((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const onHandleVoucherTranxChange = (e) => {
    const { name, value } = e.target;

    setVoucherTanxDetail((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    setVoucherTransError((prev) => ({
      ...prev,
      [name]: '',
    }));
  };

  const validateVoucherMaster = () => {
    const error = {};

    if (!voucherMasterDetail.vou_type) {
      error.vou_type = 'Select the Voucher Type';
    }

    if (!voucherMasterDetail.vou_cash_bank_name) {
      error.vou_cash_bank_name = 'Select the Option';
    }

    if (!voucherMasterDetail.vou_date) {
      error.vou_date = 'Select voucher date';
    }

    setVoucherMasterError(error);

    return Object.keys(error).length === 0;
  };

  const validateTransactionRow = () => {
    const error = {};

    if (!voucherTanxDetail.vou_p_id || !voucherTanxDetail.vou_pname) {
      error.vou_pname = 'Select the Party Name';
    }

    const amount = Number(voucherTanxDetail.vou_amt);

    if (!amount || Number.isNaN(amount) || amount <= 0) {
      error.vou_amt = 'Enter valid amount';
    }

    setVoucherTransError(error);

    return Object.keys(error).length === 0;
  };

  const buildTransactionRow = () => {
    const amount = getNumber(voucherTanxDetail.vou_amt, 0);
    const grossAmount = getNumber(
      voucherTanxDetail.vou_gross_amt || amount,
      amount,
    );

    return {
      ...voucherTanxDetail,
      id: voucherTanxDetail.id || null,
      temp_id: voucherTanxDetail.temp_id || Date.now(),
      voucher_master_id: voucherMasterId
        ? Number(voucherMasterId)
        : voucherMasterDetail?.id
          ? Number(voucherMasterDetail.id)
          : null,
      vou_p_id: Number(voucherTanxDetail.vou_p_id),
      vou_pname: voucherTanxDetail.vou_pname || '',
      vou_chq_detail: voucherTanxDetail.vou_chq_detail || '',
      vou_narr: voucherTanxDetail.vou_narr || '',
      vou_amt: amount,
      vou_agst_bill: voucherTanxDetail.vou_agst_bill || '',
      vou_gross_amt: grossAmount,
      vou_gst_per: getNumber(voucherTanxDetail.vou_gst_per, 0),
      vou_gst_amt: getNumber(voucherTanxDetail.vou_gst_amt, 0),
      vou_tax_inc: voucherTanxDetail.vou_tax_inc || '',
      vou_tax_type: voucherTanxDetail.vou_tax_type || '',
      vou_remark: voucherTanxDetail.vou_remark || '',
      status: 0,
      isNew: !voucherTanxDetail.id,
    };
  };

  const AddVoucherTranxDetail = () => {
    if (isSavingTrans || isDeletingTrans) return;

    if (!validateTransactionRow()) {
      return;
    }

    const newRow = buildTransactionRow();

    setVoucherTransList((prev) => {
      const updatedList = [...prev, newRow];

      setVoucherMasterDetail((masterPrev) => ({
        ...masterPrev,
        tot_vou_amt: calculateTotalAmount(updatedList),
      }));

      return updatedList;
    });

    toast.success('Row added successfully');
    resetTransactionForm();
  };

  const EditVoucherTranxDetail = () => {
    if (isSavingTrans || isDeletingTrans) return;

    if (!validateTransactionRow()) {
      return;
    }

    const updatedRow = buildTransactionRow();

    setVoucherTransList((prev) => {
      const updatedList = prev.map((item) => {
        if (
          updatedRow.id &&
          (item.id === updatedRow.id || item.id == updatedRow.id)
        ) {
          return updatedRow;
        }

        if (!updatedRow.id && item.temp_id === updatedRow.temp_id) {
          return updatedRow;
        }

        return item;
      });

      setVoucherMasterDetail((masterPrev) => ({
        ...masterPrev,
        tot_vou_amt: calculateTotalAmount(updatedList),
      }));

      return updatedList;
    });

    toast.success('Row updated successfully');
    resetTransactionForm();
  };

  const gotoEditModeVoucherTranxDetail = (voucherTransId, tempId = null) => {
    const findArray = voucherTransList.find((data) => {
      if (voucherTransId) {
        return data.id === voucherTransId || data.id == voucherTransId;
      }

      return data.temp_id === tempId;
    });

    if (!findArray) {
      toast.error('Transaction row not found');
      return;
    }

    setVoucherTanxDetail({
      ...initialVoucherTrns,
      ...findArray,
      voucher_master_id: voucherMasterId || voucherMasterDetail?.id || null,
    });

    setVoucherTransEditMode(true);
  };

  const ResetVoucherTranxDetail = () => {
    resetTransactionForm();
  };

  const DeleteVoucherTranxDetail = async (voucherTransId, tempId = null) => {
    const isDeleteConfirmed = window.confirm(
      'Are you sure you want to delete this item?',
    );

    if (!isDeleteConfirmed) {
      return;
    }

    // New row not saved in DB yet. Only remove from UI.
    if (!voucherTransId) {
      setVoucherTransList((prev) => {
        const updatedList = prev.filter((item) => item.temp_id !== tempId);

        setVoucherMasterDetail((masterPrev) => ({
          ...masterPrev,
          tot_vou_amt: calculateTotalAmount(updatedList),
        }));

        return updatedList;
      });

      toast.success('Row removed successfully');
      resetTransactionForm();
      return;
    }

    // Saved row. Direct soft delete API call.
    try {
      setIsDeletingTrans(true);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.delete(
        `api/VoucherMaster/deleteVouhcerTrans?voucherTransId=${voucherTransId}`,
        config,
      );

      console.log('DELETE VOUCHER TRANS RESPONSE:', response);

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        toast.success(response.message || 'Deleted successfully');

        const masterId = voucherMasterId || voucherMasterDetail?.id;

        if (masterId) {
          await GetVoucherTranxDetail(masterId);
        }

        resetTransactionForm();
      } else {
        toast.error(response.message || 'Delete failed');
      }
    } catch (error) {
      console.log('DELETE VOUCHER TRANS ERROR:', error);
      toast.error('Something went wrong!!');
    } finally {
      setIsDeletingTrans(false);
    }
  };

  const getSystemRecordsWithFlag = async (flag) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/System_Records/GetSystem_RecordsByIdWithFlag?flag=${flag}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        setSystemVoucherData(response.system_RecordsDataById || '');
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('GET SYSTEM RECORD ERROR:', error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const getVoucherList = async () => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VoucherMaster/allVoucherList`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        setVoucherList(response.vou_list_masterData || []);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('GET VOUCHER LIST ERROR:', error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const fetchLastVoucherId = async () => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VoucherMaster/voucherId`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        setVoucherMasterDetail((preData) => ({
          ...preData,
          vou_ref_no: String(parseInt(parseFloat(response?.lastId || 0) + 1)),
        }));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('FETCH LAST VOUCHER ID ERROR:', error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const getPartyCashData = async (filter) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/PartyMaster/allpartyfilter?filter=${filter}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        setPartyCashTable(response.partyMasterDetailData || []);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('GET PARTY CASH ERROR:', error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const getPartyWithoutCashData = async (slug = '', search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/PartyMaster/allpartyfilter?search=${search}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        if (slug === 'down') {
          setPartyWithOutCashDownTable(response.partyMasterDetailData || []);
        }

        if (slug === 'up') {
          setPartyWithOutCashTable(response.partyMasterDetailData || []);
        }

        if (slug === '') {
          setPartyWithOutCashTable(response.partyMasterDetailData || []);
          setPartyWithOutCashDownTable(response.partyMasterDetailData || []);
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('GET PARTY WITHOUT CASH ERROR:', error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const getVendorName = async (page = 1, limit = 10, search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VenderMaster/all?pageNo=${page}&limit=${100000}&searchKey=${search}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        if (
          response.venderMasterData &&
          response.venderMasterData.length === 1
        ) {
          setVenderMasterTable(response.venderMasterData);

          setVoucherMasterDetail((prevDetails) => ({
            ...prevDetails,
            vender_master_id: response.venderMasterData[0].id,
          }));
        } else {
          setVenderMasterTable(response.venderMasterData || []);
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('GET VENDOR ERROR:', error);
      toast.error('SomeThing went wrong!!');
    } finally {
      setPageLoading((prev) => ({ ...prev, vender: false }));
    }
  };

  const getBranchData = async (page = 1, limit = 10, search = '') => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const filterName = voucherMasterDetail.vender_master_id
        ? voucherMasterDetail.vender_master_id
        : null;

      let queryString = `pageNo=${page}&limit=100000&searchKey=${search}`;

      if (filterName) {
        queryString += `&filterName=${filterName}`;
      }

      const response = await apiService.get(
        `api/BranchMaster/all?${queryString}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        if (
          response.branchMasterData &&
          response.branchMasterData.length === 1
        ) {
          setBranchMasterTable(response.branchMasterData);

          setVoucherMasterDetail((prevDetails) => ({
            ...prevDetails,
            branch_master_id: response.branchMasterData[0].id,
          }));
        } else if (
          response.branchMasterData &&
          response.branchMasterData.length === 0
        ) {
          setBranchMasterTable(response.branchMasterData);

          setErrorMessage((prevDetails) => ({
            ...prevDetails,
            branch_master_id: 'Branch is required',
          }));
        } else {
          setBranchMasterTable(response.branchMasterData || []);
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('GET BRANCH ERROR:', error);
      toast.error('SomeThing went wrong!!');
    } finally {
      setPageLoading((prev) => ({ ...prev, branch: false }));
    }
  };

  const getVoucherDetail = async (voucherId) => {
    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VoucherMaster/voucherDetail?voucherId=${voucherId}`,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        setEditMode(true);
        setVoucherMasterDetail(response.vou_masterByID);
        setVoucherMasterId(response.vou_masterByID.id);

        setVoucherTanxDetail((prevState) => ({
          ...prevState,
          voucher_master_id: response.vou_masterByID.id,
        }));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('GET VOUCHER DETAIL ERROR:', error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const GetVoucherTranxDetail = async (VoucherTransId) => {
    if (!VoucherTransId) {
      setVoucherTransList([]);
      return;
    }

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const response = await apiService.get(
        `api/VoucherMaster/allVoucherTrans?VoucherTransId=${VoucherTransId}`,
        config,
      );

      console.log('GET VOUCHER TRANS RESPONSE:', response);

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        const rows = response.vou_Trn_Master_List || [];

        setVoucherTransList(rows);

        setVoucherMasterDetail((prevState) => ({
          ...prevState,
          tot_vou_amt: calculateTotalAmount(rows),
        }));
      } else {
        toast.error(response.message || 'Transaction list not found');
        setVoucherTransList([]);
      }
    } catch (error) {
      console.log('GET VOUCHER TRANS ERROR:', error);
      toast.error('Something went wrong!!');
    }
  };

  const buildVoucherRowsForSave = () => {
    return voucherTransList.map((item) => ({
      id: item.id || null,
      unique_trn_id: item.unique_trn_id || null,
      client_purchaser_code:
        item.client_purchaser_code === '' ? null : item.client_purchaser_code,
      client_purchaser_name: item.client_purchaser_name || '',
      agent_code: item.agent_code === '' ? null : item.agent_code,
      agent_name: item.agent_name || '',
      vender_code: item.vender_code === '' ? null : item.vender_code,
      vender_name: item.vender_name || '',
      voucher_master_id: Number(voucherMasterId || voucherMasterDetail.id),
      vou_p_id: Number(item.vou_p_id),
      vou_pname: item.vou_pname || '',
      vou_chq_detail: item.vou_chq_detail || '',
      vou_narr: item.vou_narr || '',
      vou_amt: getNumber(item.vou_amt, 0),
      vou_agst_bill: item.vou_agst_bill || '',
      username: item.username || '',
      status: 0,
      vou_gst_amt: getNumber(item.vou_gst_amt, 0),
      vou_gst_per: getNumber(item.vou_gst_per, 0),
      vou_gross_amt: getNumber(item.vou_gross_amt || item.vou_amt, 0),
      vou_remark: item.vou_remark || '',
      vou_tax_inc: item.vou_tax_inc || '',
      vou_tax_type: item.vou_tax_type || '',
    }));
  };

  const AddVoucherMasterData = async () => {
    if (!validateVoucherMaster()) {
      return;
    }

    try {
      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const params = {
        ...voucherMasterDetail,
        voucherMasterTranxKey: [],
      };

      const response = await apiService.post(
        `api/VoucherMaster/create`,
        params,
        config,
      );

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        toast.success(response.message || 'Voucher master saved successfully');

        setVoucherMasterDetail(response.vou_masterByID);
        setVoucherMasterId(response.vou_masterByID.id);

        setVoucherTanxDetail((prevState) => ({
          ...prevState,
          voucher_master_id: response.vou_masterByID.id,
        }));

        setEditMode(true);

        if (voucherBankRef.current) {
          voucherBankRef.current.value = '';
        }

        if (voucherTypeRef.current) {
          voucherTypeRef.current.value = '';
        }

        if (inputRefs.current) {
          inputRefs.current.forEach((ref) => {
            if (ref) {
              ref.value = '';
            }
          });
        }
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log('CREATE VOUCHER MASTER ERROR:', error);
      toast.error('SomeThing went wrong!!');
    }
  };

  const UpdateVoucherMasterData = async () => {
    if (!validateVoucherMaster()) {
      return;
    }

    if (!voucherMasterId && !voucherMasterDetail.id) {
      toast.error('Voucher master id missing. Please save master first.');
      return;
    }

    if (!voucherTransList || voucherTransList.length === 0) {
      toast.error('Please add at least one voucher detail row');
      return;
    }

    try {
      setIsSavingTrans(true);

      const config = {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
        },
      };

      const voucherRows = buildVoucherRowsForSave();
      const totalAmount = calculateTotalAmount(voucherRows);

      const params = {
        ...voucherMasterDetail,
        id: Number(voucherMasterId || voucherMasterDetail.id),
        tot_vou_amt: totalAmount,
        voucherMasterTranxKey: voucherRows,

        // Important:
        // Do not send voucherTranxDeleteArray.
        // Delete is handled by direct soft-delete API.
      };

      console.log('FINAL SAVE PARAMS MASTER + ROWS:', params);

      const response = await apiService.put(
        `api/VoucherMaster/update?voucherId=${params.id}`,
        params,
        config,
      );

      console.log('FINAL SAVE RESPONSE:', response);

      if (response.response && response.response.data.errors) {
        toast.error(response.response?.data?.errors);
        return;
      }

      if (response.status === true) {
        toast.success(response.message || 'Voucher saved successfully');

        await GetVoucherTranxDetail(params.id);

        setVoucherMasterDetail((prev) => ({
          ...prev,
          tot_vou_amt: totalAmount,
        }));

        resetTransactionForm();
      } else {
        toast.error(response.message || 'Voucher not saved');
      }
    } catch (error) {
      console.log('FINAL SAVE ERROR:', error);
      toast.error('Something went wrong!!');
    } finally {
      setIsSavingTrans(false);
    }
  };

  const handleSelectCashParty = async (event, value) => {
    if (value === null || value === undefined) {
      setVoucherMasterDetail((prevData) => ({
        ...prevData,
        vou_cash_bank_id: null,
        vou_cash_bank_name: '',
      }));
      return;
    }

    const findData = partyCashTable.find((data) => data.id == value.id);

    if (!findData) {
      return;
    }

    setVoucherMasterDetail((prevData) => ({
      ...prevData,
      vou_cash_bank_id: findData.id,
      vou_cash_bank_name: findData.name,
    }));

    setVoucherMasterError((prev) => ({
      ...prev,
      vou_cash_bank_name: '',
    }));
  };

  const handleSelectWithoutCashParty = async (event, value) => {
    if (value === null || value === undefined) {
      setVoucherMasterDetail((prevData) => ({
        ...prevData,
        vou_cash_bank_id: null,
        vou_cash_bank_name: '',
      }));
      return;
    }

    const findData = partyWithOutCashTable.find((data) => data.id == value.id);

    if (!findData) {
      return;
    }

    setVoucherMasterDetail((prevData) => ({
      ...prevData,
      vou_cash_bank_id: findData.id,
      vou_cash_bank_name: findData.name,
    }));

    setVoucherMasterError((prev) => ({
      ...prev,
      vou_cash_bank_name: '',
    }));
  };

  const handleSelectDownCashParty = async (event, value) => {
    if (value === null || value === undefined) {
      setVoucherTanxDetail((prev) => ({
        ...prev,
        vou_p_id: null,
        vou_pname: '',
      }));
      return;
    }

    const findData = partyCashTable.find((data) => data.id == value.id);

    if (!findData) {
      return;
    }

    setVoucherTanxDetail((prevData) => ({
      ...prevData,
      vou_p_id: findData.id,
      vou_pname: findData.name,
    }));

    setVoucherTransError((prev) => ({
      ...prev,
      vou_pname: '',
    }));
  };

  const handleSelectDownWithoutCashParty = async (event, value) => {
    if (value === null || value === undefined) {
      setVoucherTanxDetail((prev) => ({
        ...prev,
        vou_p_id: null,
        vou_pname: '',
      }));
      return;
    }

    const findData = partyWithOutCashDownTable.find(
      (data) => data.id == value.id,
    );

    if (!findData) {
      return;
    }

    setVoucherTanxDetail((prevData) => ({
      ...prevData,
      vou_p_id: findData.id,
      vou_pname: findData.name,
    }));

    setVoucherTransError((prev) => ({
      ...prev,
      vou_pname: '',
    }));
  };

  const goTODeleteModel = (id) => {
    const currentUrl = `${window.location.origin}`;
    const url = `${currentUrl}/commonDelete?itemId=${id}&flag=voucher`;

    window.open(url, '_blank');

    setTimeout(() => {
      window.close();
    }, 1000);
  };

  const onHandleBackParty = () => {
    navigate(-1);
  };

  useEffect(() => {
    getVoucherList();
  }, []);

  useEffect(() => {
    if (voucherMasterDetail.vou_type === 'Receipt') {
      getSystemRecordsWithFlag('voucher_recipted');
    } else if (voucherMasterDetail.vou_type === 'Payment') {
      getSystemRecordsWithFlag('voucher_payment');
    } else if (voucherMasterDetail.vou_type === 'Contra') {
      getSystemRecordsWithFlag('voucher_contra');
    } else if (voucherMasterDetail.vou_type === 'Journal') {
      getSystemRecordsWithFlag('voucher_journal');
    } else if (voucherMasterDetail.vou_type === 'Credit Note') {
      getSystemRecordsWithFlag('voucher_credit');
    } else if (voucherMasterDetail.vou_type === 'Debit Note') {
      getSystemRecordsWithFlag('voucher_debit');
    }
  }, [voucherMasterDetail.vou_type]);

  useEffect(() => {
    fetchLastVoucherId();

    const today = moment();
    const maxDate = today.format('YYYY-MM-DD');
    const selectedDate = new Date(maxDate);
    const selectedMonth = selectedDate.getMonth();

    let startYear;
    let endYear;

    if (selectedMonth < 3) {
      startYear = selectedDate.getFullYear() - 1;
      endYear = selectedDate.getFullYear();
    } else {
      startYear = selectedDate.getFullYear();
      endYear = selectedDate.getFullYear() + 1;
    }

    setVoucherMasterDetail((preData) => ({
      ...preData,
      vou_fa_year: `${startYear}-${endYear}`,
      vou_date: maxDate,
    }));

    getPartyCashData('cash');
    getPartyWithoutCashData();
  }, []);

  useEffect(() => {
    if (location.state) {
      getVoucherDetail(location.state.voucherId);
      GetVoucherTranxDetail(location.state.voucherId);
    }
  }, [location.state]);

  useEffect(() => {
    getVendorName();
    getBranchData();
  }, [voucherMasterDetail?.vender_master_id]);

  useEffect(() => {
    const allApisLoaded = Object.values(pageloading).every(
      (status) => status === false,
    );

    if (!allApisLoaded) return;

    const newErrors = {};

    if (!venderMaster || venderMaster.length === 0) {
      newErrors.vender_master_id = 'Vender is required.';
    }

    if (!branchMaster || branchMaster.length === 0) {
      newErrors.branch_master_id = 'Branch is required.';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrorMessage(newErrors);
    } else {
      setErrorMessage({});
    }
  }, [branchMaster, venderMaster, pageloading]);

  useEffect(() => {
    const totalAmount = calculateTotalAmount(voucherTransList);

    setVoucherMasterDetail((prevState) => ({
      ...prevState,
      tot_vou_amt: totalAmount,
    }));
  }, [voucherTransList]);

  useEffect(() => {
    const grossValue = voucherTanxDetail.vou_gross_amt;
    const gstValue = voucherTanxDetail.vou_gst_per;

    if (grossValue === '' || grossValue === null || grossValue === undefined) {
      return;
    }

    const grossAmt = Number(grossValue || 0);
    const gstPer = Number(gstValue || 0);

    if (Number.isNaN(grossAmt) || Number.isNaN(gstPer)) {
      return;
    }

    const gstAmt = (grossAmt * gstPer) / 100;
    const totalAmount = grossAmt + gstAmt;

    setVoucherTanxDetail((prevState) => ({
      ...prevState,
      vou_gst_amt: gstAmt,
      vou_amt: totalAmount,
    }));
  }, [voucherTanxDetail.vou_gross_amt, voucherTanxDetail.vou_gst_per]);

  return (
    <Row>
      <Col>
        <Card className='bg-white mb-4 shadow-sm border-0 rounded'>
          <CardTitle
            tag='div'
            className='border-bottom px-4 py-3 mb-0 d-flex align-items-center justify-content-between flex-wrap sticky-top bg-white'
            style={{ top: 0, zIndex: 1020 }}
          >
            <div className='d-flex align-items-center'>
              <span
                className='d-flex align-items-center justify-content-center bg-primary text-white rounded mr-3'
                style={{ width: 36, height: 36, fontSize: 16 }}
              >
                <i className='bi bi-receipt'></i>
              </span>
              <div>
                <h6 className='mb-0 font-weight-bold text-dark'>
                  Voucher Detail
                </h6>
                <small className='text-muted'>Manage voucher information</small>
              </div>
            </div>

            <div
              className='d-flex align-items-center mt-2 mt-sm-0'
              style={{ gap: 8 }}
            >
              {editMode && (
                <Button
                  color='danger'
                  size='sm'
                  className='d-flex flex-column align-items-center px-3 py-2 border-0 shadow-sm'
                  style={{ minWidth: 60 }}
                  onClick={() => goTODeleteModel(voucherMasterDetail.id)}
                >
                  <i className='bi bi-trash mb-1'></i>
                  <span
                    style={{
                      fontSize: 10,
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                    }}
                  >
                    DELETE
                  </span>
                </Button>
              )}

              {editMode && (
                <Button
                  color='success'
                  size='sm'
                  className='d-flex flex-column align-items-center px-3 py-2 border-0 shadow-sm'
                  style={{ minWidth: 60 }}
                  disabled={isSavingTrans || isDeletingTrans}
                  onClick={UpdateVoucherMasterData}
                >
                  <i className='bi bi-save mb-1'></i>
                  <span
                    style={{
                      fontSize: 10,
                      fontWeight: 600,
                      letterSpacing: '0.03em',
                    }}
                  >
                    {isSavingTrans ? 'SAVING…' : 'SAVE'}
                  </span>
                </Button>
              )}

              <Button
                color='secondary'
                size='sm'
                className='d-flex flex-column align-items-center px-3 py-2 border-0 shadow-sm'
                style={{ minWidth: 60 }}
                onClick={onHandleBackParty}
              >
                <i className='bi bi-arrow-left mb-1'></i>
                <span
                  style={{
                    fontSize: 10,
                    fontWeight: 600,
                    letterSpacing: '0.03em',
                  }}
                >
                  BACK
                </span>
              </Button>
            </div>
          </CardTitle>

          <CardBody className='px-4 py-4'>
            <Row>
              <Col sm='12'>
                {(venderMaster.length === 0 || venderMaster.length > 1) && (
                  <FormGroup>
                    <Label
                      for='vender_master_id'
                      className='font-weight-semibold text-secondary small text-uppercase mb-1'
                      style={{ letterSpacing: '0.06em' }}
                    >
                      Vendor Name
                    </Label>
                    <Input
                      type='select'
                      className='custom-select custom-select-sm border rounded'
                      id='vender_master_id'
                      name='vender_master_id'
                      value={voucherMasterDetail.vender_master_id || ''}
                      onChange={handleChange}
                    >
                      <option value=''>— Select Vendor —</option>
                      {venderMaster.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.vender_name}
                        </option>
                      ))}
                    </Input>
                    {errorMessage.vender_master_id && (
                      <FormText color='danger'>
                        <i className='bi bi-exclamation-circle mr-1'></i>
                        {errorMessage.vender_master_id}
                      </FormText>
                    )}
                  </FormGroup>
                )}
              </Col>

              <Col sm={12}>
                {(branchMaster.length === 0 || branchMaster.length > 1) && (
                  <FormGroup>
                    <Label
                      for='branch_master_id'
                      className='font-weight-semibold text-secondary small text-uppercase mb-1'
                      style={{ letterSpacing: '0.06em' }}
                    >
                      Branch Name
                    </Label>
                    <Input
                      type='select'
                      className='custom-select custom-select-sm border rounded'
                      id='branch_master_id'
                      name='branch_master_id'
                      value={voucherMasterDetail.branch_master_id || ''}
                      onChange={handleChange}
                    >
                      <option value=''>— Select Branch —</option>
                      {branchMaster.map((option) => (
                        <option key={option.id} value={option.id}>
                          {option.branch_name}
                        </option>
                      ))}
                    </Input>
                    {errorMessage.branch_master_id && (
                      <FormText color='danger'>
                        <i className='bi bi-exclamation-circle mr-1'></i>
                        {errorMessage.branch_master_id}
                      </FormText>
                    )}
                  </FormGroup>
                )}
              </Col>
            </Row>

            <Form>
              <div
                className='rounded p-4 mb-4 border'
                style={{
                  backgroundColor: getColorForVoucherType(
                    voucherMasterDetail?.vou_type,
                  ),
                  borderColor: '#dee2e6',
                }}
              >
                <div className='d-flex align-items-center mb-3'>
                  <span
                    className='bg-primary text-white rounded px-2 py-1 mr-2'
                    style={{
                      fontSize: 11,
                      fontWeight: 700,
                      letterSpacing: '0.07em',
                    }}
                  >
                    VOUCHER
                  </span>
                  <h6 className='mb-0 font-weight-bold text-dark'>
                    Voucher Information
                  </h6>
                </div>

                <Row>
                  <Col xl={3}>
                    <FormGroup>
                      <Label
                        for='vou_type_id'
                        className='font-weight-semibold text-secondary small text-uppercase mb-1'
                        style={{ letterSpacing: '0.06em' }}
                      >
                        Voucher Type
                      </Label>
                      <Input
                        type='select'
                        className='custom-select custom-select-sm border rounded'
                        name='vou_type_id'
                        id='vou_type_id'
                        value={voucherMasterDetail?.vou_type_id || ''}
                        onChange={handleChange}
                        innerRef={voucherTypeRef}
                      >
                        <option value=''>— Select —</option>
                        {voucherList.map((option) => (
                          <option
                            key={option.vou_type_id}
                            value={option.vou_type_id}
                          >
                            {option.vou_type_name}
                          </option>
                        ))}
                      </Input>
                      {voucherMasterError.vou_type && (
                        <FormText color='danger'>
                          <i className='bi bi-exclamation-circle mr-1'></i>
                          {voucherMasterError.vou_type}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col xl={3}>
                    <FormGroup>
                      <Label
                        for='vou_fa_year'
                        className='font-weight-semibold text-secondary small text-uppercase mb-1'
                        style={{ letterSpacing: '0.06em' }}
                      >
                        Financial Year
                      </Label>
                      <Input
                        type='text'
                        name='vou_fa_year'
                        id='vou_fa_year'
                        value={voucherMasterDetail?.vou_fa_year || ''}
                        onChange={handleChange}
                        disabled
                        className='bg-light border rounded form-control-sm'
                      />
                    </FormGroup>
                  </Col>

                  <Col xl={3}>
                    <FormGroup>
                      <Label
                        for='vou_ref_no'
                        className='font-weight-semibold text-secondary small text-uppercase mb-1'
                        style={{ letterSpacing: '0.06em' }}
                      >
                        Ref Number
                      </Label>
                      <Input
                        type='text'
                        name='vou_ref_no'
                        id='vou_ref_no'
                        value={voucherMasterDetail?.vou_ref_no || ''}
                        onChange={handleChange}
                        className='border rounded form-control-sm'
                      />
                    </FormGroup>
                  </Col>

                  <Col xl={3}>
                    <FormGroup>
                      <Label
                        for='vou_date'
                        className='font-weight-semibold text-secondary small text-uppercase mb-1'
                        style={{ letterSpacing: '0.06em' }}
                      >
                        Date
                      </Label>
                      <Input
                        type='date'
                        name='vou_date'
                        id='vou_date'
                        value={
                          voucherMasterDetail?.vou_date?.split('T')[0] || ''
                        }
                        onChange={handleChange}
                        className='border rounded form-control-sm'
                      />
                      {voucherMasterError.vou_date && (
                        <FormText color='danger'>
                          <i className='bi bi-exclamation-circle mr-1'></i>
                          {voucherMasterError.vou_date}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <FormGroup>
                      <Label
                        for='vou_cash_bank_name'
                        className='font-weight-semibold text-secondary small text-uppercase mb-1'
                        style={{ letterSpacing: '0.06em' }}
                      >
                        {voucherMasterDetail?.vou_type === 'Journal' ||
                        voucherMasterDetail?.vou_type === 'Credit Note' ||
                        voucherMasterDetail?.vou_type === 'Debit Note'
                          ? 'Party Name'
                          : 'Cash / Bank Name'}
                      </Label>

                      {voucherMasterDetail?.vou_type === 'Payment' ||
                      voucherMasterDetail?.vou_type === 'Receipt' ||
                      voucherMasterDetail?.vou_type === 'Contra' ? (
                        <Autocomplete
                          size='small'
                          autoHighlight
                          id='vou_cash_bank_name'
                          name='vou_cash_bank_name'
                          options={partyCashTable || []}
                          getOptionLabel={(option) =>
                            `${option.name || ''} - ${
                              option.party_agr_code || ''
                            } - ${option.party_company_name || ''} - ${
                              option.mobile_number || ''
                            }`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder='Select Party Code'
                              size='small'
                            />
                          )}
                          renderOption={(props, option, { index }) => (
                            <li {...props} key={option.id || index}>
                              {`${option.name || ''} - ${
                                option.party_agr_code || ''
                              } - ${option.party_company_name || ''} - ${
                                option.mobile_number || ''
                              }`}
                            </li>
                          )}
                          value={
                            partyCashTable.find(
                              (option) =>
                                option.id ===
                                  voucherMasterDetail?.vou_cash_bank_id ||
                                option.id ==
                                  voucherMasterDetail?.vou_cash_bank_id,
                            ) || null
                          }
                          onChange={handleSelectCashParty}
                          readOnly={voucherMasterDetail.vou_type === ''}
                        />
                      ) : (
                        <Autocomplete
                          size='small'
                          autoHighlight
                          id='vou_cash_bank_name'
                          name='vou_cash_bank_name'
                          options={partyWithOutCashTable || []}
                          getOptionLabel={(option) =>
                            `${option.name || ''} - ${
                              option.party_agr_code || ''
                            } - ${option.party_company_name || ''} - ${
                              option.mobile_number || ''
                            }`
                          }
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder='Select Party Code'
                              size='small'
                            />
                          )}
                          renderOption={(props, option, { index }) => (
                            <li {...props} key={option.id || index}>
                              {`${option.name || ''} - ${
                                option.party_agr_code || ''
                              } - ${option.party_company_name || ''} - ${
                                option.mobile_number || ''
                              }`}
                            </li>
                          )}
                          value={
                            partyWithOutCashTable.find(
                              (option) =>
                                option.id ===
                                  voucherMasterDetail?.vou_cash_bank_id ||
                                option.id ==
                                  voucherMasterDetail?.vou_cash_bank_id,
                            ) || null
                          }
                          onChange={handleSelectWithoutCashParty}
                          readOnly={voucherMasterDetail.vou_type === ''}
                        />
                      )}

                      {voucherMasterError.vou_cash_bank_name && (
                        <FormText color='danger'>
                          <i className='bi bi-exclamation-circle mr-1'></i>
                          {voucherMasterError.vou_cash_bank_name}
                        </FormText>
                      )}
                    </FormGroup>
                  </Col>

                  <Col xl={3}>
                    <FormGroup>
                      <Label
                        for='tot_vou_amt'
                        className='font-weight-semibold text-secondary small text-uppercase mb-1'
                        style={{ letterSpacing: '0.06em' }}
                      >
                        Total Amount
                      </Label>
                      <div className='input-group input-group-sm'>
                        <div className='input-group-prepend'>
                          <span className='input-group-text bg-light border-right-0'>
                            <i className='bi bi-currency-rupee'></i>
                          </span>
                        </div>
                        <Input
                          type='text'
                          name='tot_vou_amt'
                          id='tot_vou_amt'
                          value={voucherMasterDetail?.tot_vou_amt || 0}
                          onChange={handleChange}
                          disabled
                          className='bg-light border-left-0 font-weight-bold'
                        />
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              {editMode && (
                <div
                  className='rounded p-4 mb-4 border'
                  style={{
                    backgroundColor: getColorForVoucherType(
                      voucherMasterDetail?.vou_type,
                    ),
                    borderColor: '#dee2e6',
                  }}
                >
                  <div className='d-flex align-items-center mb-3'>
                    <span
                      className='bg-success text-white rounded px-2 py-1 mr-2'
                      style={{
                        fontSize: 11,
                        fontWeight: 700,
                        letterSpacing: '0.07em',
                      }}
                    >
                      TRANSACTION
                    </span>
                    <h6 className='mb-0 font-weight-bold text-dark'>
                      Transaction Details
                    </h6>
                  </div>

                  <Row>
                    <Col>
                      <FormGroup>
                        <Label
                          for='vou_p_id'
                          className='font-weight-semibold text-secondary small text-uppercase mb-1'
                          style={{ letterSpacing: '0.06em' }}
                        >
                          Party Name
                        </Label>

                        {voucherMasterDetail?.vou_type === 'Contra' ? (
                          <Autocomplete
                            size='small'
                            autoHighlight
                            id='vou_pname'
                            name='vou_pname'
                            options={partyCashTable || []}
                            getOptionLabel={(option) => option.name || ''}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label='Select Cash/Bank'
                                size='small'
                              />
                            )}
                            renderOption={(props, option, { index }) => (
                              <li {...props} key={option.id || index}>
                                {option.name}
                              </li>
                            )}
                            value={
                              partyCashTable.find(
                                (option) =>
                                  option.id === voucherTanxDetail.vou_p_id ||
                                  option.id == voucherTanxDetail.vou_p_id,
                              ) || null
                            }
                            onChange={handleSelectDownCashParty}
                            readOnly={voucherMasterDetail.vou_type === ''}
                          />
                        ) : (
                          <Autocomplete
                            size='small'
                            sx={{ width: 300 }}
                            autoHighlight
                            id='vou_pname'
                            name='vou_pname'
                            options={partyWithOutCashDownTable || []}
                            getOptionLabel={(option) => option.name || ''}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label='Select Party Name'
                                size='small'
                              />
                            )}
                            renderOption={(props, option, { index }) => (
                              <li {...props} key={option.id || index}>
                                {option.name}
                              </li>
                            )}
                            value={
                              partyWithOutCashDownTable.find(
                                (option) =>
                                  option.id === voucherTanxDetail.vou_p_id ||
                                  option.id == voucherTanxDetail.vou_p_id ||
                                  option.name === voucherTanxDetail.vou_pname,
                              ) || null
                            }
                            onChange={handleSelectDownWithoutCashParty}
                            readOnly={voucherMasterDetail.vou_type === ''}
                          />
                        )}

                        {voucherTransError.vou_pname && (
                          <FormText color='danger'>
                            <i className='bi bi-exclamation-circle mr-1'></i>
                            {voucherTransError.vou_pname}
                          </FormText>
                        )}
                      </FormGroup>
                    </Col>

                    <Col>
                      <FormGroup>
                        <Label
                          for='vou_chq_detail'
                          className='font-weight-semibold text-secondary small text-uppercase mb-1'
                          style={{ letterSpacing: '0.06em' }}
                        >
                          Cheque Detail
                        </Label>
                        <Input
                          type='text'
                          name='vou_chq_detail'
                          id='vou_chq_detail'
                          value={voucherTanxDetail.vou_chq_detail || ''}
                          onChange={onHandleVoucherTranxChange}
                          className='border rounded form-control-sm'
                          placeholder='Enter cheque detail'
                        />
                      </FormGroup>
                    </Col>

                    <Col xl={4}>
                      <FormGroup>
                        <Label
                          for='vou_agst_bill'
                          className='font-weight-semibold text-secondary small text-uppercase mb-1'
                          style={{ letterSpacing: '0.06em' }}
                        >
                          Against Bill
                        </Label>
                        <Input
                          type='text'
                          name='vou_agst_bill'
                          id='vou_agst_bill'
                          value={voucherTanxDetail.vou_agst_bill || ''}
                          onChange={onHandleVoucherTranxChange}
                          className='border rounded form-control-sm'
                          placeholder='Bill reference'
                        />
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row className='align-items-end'>
                    <Col xl={8}>
                      <FormGroup>
                        <Label
                          for='vou_narr'
                          className='font-weight-semibold text-secondary small text-uppercase mb-1'
                          style={{ letterSpacing: '0.06em' }}
                        >
                          Narration
                        </Label>
                        <Input
                          type='text'
                          name='vou_narr'
                          id='vou_narr'
                          value={voucherTanxDetail.vou_narr || ''}
                          onChange={onHandleVoucherTranxChange}
                          className='border rounded form-control-sm'
                          placeholder='Enter narration'
                        />
                      </FormGroup>
                    </Col>

                    <Col xl={4}>
                      <FormGroup>
                        <Label
                          for='vou_tax_inc'
                          className='font-weight-semibold text-secondary small text-uppercase mb-1'
                          style={{ letterSpacing: '0.06em' }}
                        >
                          Tax Include
                        </Label>
                        <Input
                          type='select'
                          className='custom-select custom-select-sm border rounded'
                          name='vou_tax_inc'
                          id='vou_tax_inc'
                          value={voucherTanxDetail.vou_tax_inc || ''}
                          onChange={onHandleVoucherTranxChange}
                        >
                          <option value=''>— Select —</option>
                          <option value='yes'>Yes</option>
                          <option value='no'>No</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col xl={4}>
                      <FormGroup>
                        <Label
                          for='vou_tax_type'
                          className='font-weight-semibold text-secondary small text-uppercase mb-1'
                          style={{ letterSpacing: '0.06em' }}
                        >
                          Tax Type
                        </Label>
                        <Input
                          type='select'
                          className='custom-select custom-select-sm border rounded'
                          name='vou_tax_type'
                          id='vou_tax_type'
                          value={voucherTanxDetail.vou_tax_type || ''}
                          onChange={onHandleVoucherTranxChange}
                        >
                          <option value=''>— Select —</option>
                          <option value='IGST'>IGST</option>
                          <option value='SGST-CGST'>SGST / CGST</option>
                        </Input>
                      </FormGroup>
                    </Col>

                    {systemVoucherData.grand_total_yn === 'yes' && (
                      <Col xl={4}>
                        <FormGroup>
                          <Label
                            for='vou_gross_amt'
                            className='font-weight-semibold text-secondary small text-uppercase mb-1'
                            style={{ letterSpacing: '0.06em' }}
                          >
                            Gross Amount
                          </Label>
                          <div className='input-group input-group-sm'>
                            <div className='input-group-prepend'>
                              <span className='input-group-text bg-light'>
                                <i className='bi bi-currency-rupee'></i>
                              </span>
                            </div>
                            <Input
                              type='number'
                              name='vou_gross_amt'
                              id='vou_gross_amt'
                              value={voucherTanxDetail.vou_gross_amt || ''}
                              onChange={onHandleVoucherTranxChange}
                              placeholder='0.00'
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}

                    {systemVoucherData.gst_percentage_yn === 'yes' && (
                      <Col xl={4}>
                        <FormGroup>
                          <Label
                            for='vou_gst_per'
                            className='font-weight-semibold text-secondary small text-uppercase mb-1'
                            style={{ letterSpacing: '0.06em' }}
                          >
                            Tax %
                          </Label>
                          <div className='input-group input-group-sm'>
                            <Input
                              type='number'
                              name='vou_gst_per'
                              id='vou_gst_per'
                              value={voucherTanxDetail.vou_gst_per || ''}
                              onChange={onHandleVoucherTranxChange}
                              placeholder='0'
                            />
                            <div className='input-group-append'>
                              <span className='input-group-text bg-light'>
                                %
                              </span>
                            </div>
                          </div>
                        </FormGroup>
                      </Col>
                    )}

                    {systemVoucherData.gst_amount_yn === 'yes' && (
                      <Col xl={4}>
                        <FormGroup>
                          <Label
                            for='vou_gst_amt'
                            className='font-weight-semibold text-secondary small text-uppercase mb-1'
                            style={{ letterSpacing: '0.06em' }}
                          >
                            Tax Amount
                          </Label>
                          <div className='input-group input-group-sm'>
                            <div className='input-group-prepend'>
                              <span className='input-group-text bg-light'>
                                <i className='bi bi-currency-rupee'></i>
                              </span>
                            </div>
                            <Input
                              type='number'
                              name='vou_gst_amt'
                              id='vou_gst_amt'
                              value={voucherTanxDetail.vou_gst_amt || ''}
                              onChange={onHandleVoucherTranxChange}
                              placeholder='0.00'
                            />
                          </div>
                        </FormGroup>
                      </Col>
                    )}

                    <Col xl={4}>
                      <FormGroup>
                        <Label
                          for='vou_amt'
                          className='font-weight-semibold text-secondary small text-uppercase mb-1'
                          style={{ letterSpacing: '0.06em' }}
                        >
                          Amount
                        </Label>
                        <div className='input-group input-group-sm'>
                          <div className='input-group-prepend'>
                            <span className='input-group-text bg-primary text-white'>
                              <i className='bi bi-currency-rupee'></i>
                            </span>
                          </div>
                          <Input
                            type='number'
                            name='vou_amt'
                            id='vou_amt'
                            value={voucherTanxDetail.vou_amt || ''}
                            onChange={onHandleVoucherTranxChange}
                            placeholder='0.00'
                            className='font-weight-bold'
                          />
                        </div>
                        {voucherTransError.vou_amt && (
                          <FormText color='danger'>
                            <i className='bi bi-exclamation-circle mr-1'></i>
                            {voucherTransError.vou_amt}
                          </FormText>
                        )}
                      </FormGroup>
                    </Col>

                    <Col
                      className='d-flex align-items-end pb-3'
                      style={{ gap: 8 }}
                    >
                      {voucherTransEditMode ? (
                        <>
                          <Button
                            color='primary'
                            size='sm'
                            onClick={EditVoucherTranxDetail}
                            className='px-4 shadow-sm'
                            disabled={isDeletingTrans}
                          >
                            <i className='bi bi-check-lg mr-1'></i>
                            Update
                          </Button>
                          <Button
                            color='outline-danger'
                            size='sm'
                            onClick={ResetVoucherTranxDetail}
                            className='px-3'
                            disabled={isDeletingTrans}
                          >
                            <i className='bi bi-x-lg mr-1'></i>
                            Reset
                          </Button>
                        </>
                      ) : (
                        <Button
                          color='primary'
                          size='sm'
                          onClick={AddVoucherTranxDetail}
                          className='px-4 shadow-sm'
                          disabled={isDeletingTrans}
                        >
                          <i className='bi bi-plus-lg mr-1'></i>
                          Add Row
                        </Button>
                      )}
                    </Col>
                  </Row>
                </div>
              )}

              {editMode && (
                <div className='border rounded overflow-hidden'>
                  <div className='d-flex align-items-center px-3 py-2 border-bottom bg-light'>
                    <i className='bi bi-table mr-2 text-primary'></i>
                    <h6
                      className='mb-0 font-weight-bold text-dark small text-uppercase'
                      style={{ letterSpacing: '0.06em' }}
                    >
                      Voucher Entries
                    </h6>
                    {voucherTransList && voucherTransList.length > 0 && (
                      <span className='badge badge-primary ml-2'>
                        {voucherTransList.length}
                      </span>
                    )}
                  </div>

                  <CardBody className='p-0'>
                    <Table hover responsive className='mb-0' size='sm'>
                      <thead>
                        <tr className='bg-light'>
                          <th
                            className='border-0 text-secondary small text-uppercase px-3 py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            #
                          </th>
                          <th
                            className='border-0 text-secondary small text-uppercase py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            Party Name
                          </th>
                          <th
                            className='border-0 text-secondary small text-uppercase py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            Cheque Detail
                          </th>
                          <th
                            className='border-0 text-secondary small text-uppercase py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            Narration
                          </th>

                          {systemVoucherData.grand_total_yn === 'yes' && (
                            <th
                              className='border-0 text-secondary small text-uppercase py-2'
                              style={{
                                letterSpacing: '0.05em',
                                fontWeight: 700,
                              }}
                            >
                              Gross Amt
                            </th>
                          )}

                          {systemVoucherData.gst_percentage_yn === 'yes' && (
                            <th
                              className='border-0 text-secondary small text-uppercase py-2'
                              style={{
                                letterSpacing: '0.05em',
                                fontWeight: 700,
                              }}
                            >
                              GST %
                            </th>
                          )}

                          {systemVoucherData.gst_amount_yn === 'yes' && (
                            <th
                              className='border-0 text-secondary small text-uppercase py-2'
                              style={{
                                letterSpacing: '0.05em',
                                fontWeight: 700,
                              }}
                            >
                              GST Amt
                            </th>
                          )}

                          <th
                            className='border-0 text-secondary small text-uppercase py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            Amount
                          </th>
                          <th
                            className='border-0 text-secondary small text-uppercase py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            Against Bill
                          </th>
                          <th
                            className='border-0 text-secondary small text-uppercase py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            Edit
                          </th>
                          <th
                            className='border-0 text-secondary small text-uppercase py-2'
                            style={{ letterSpacing: '0.05em', fontWeight: 700 }}
                          >
                            Delete
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {voucherTransList && voucherTransList.length > 0 ? (
                          voucherTransList.map((tranx, index) => (
                            <tr key={tranx.id || tranx.temp_id || index}>
                              <td className='px-3 text-muted small align-middle'>
                                {index + 1}
                              </td>
                              <td className='align-middle font-weight-medium'>
                                {tranx.vou_pname}
                              </td>
                              <td className='align-middle text-muted small'>
                                {tranx.vou_chq_detail}
                              </td>
                              <td className='align-middle text-muted small'>
                                {tranx.vou_narr}
                              </td>

                              {systemVoucherData.grand_total_yn === 'yes' && (
                                <td className='align-middle'>
                                  {tranx.vou_gross_amt}
                                </td>
                              )}

                              {systemVoucherData.gst_percentage_yn ===
                                'yes' && (
                                <td className='align-middle'>
                                  {tranx.vou_gst_per}
                                </td>
                              )}

                              {systemVoucherData.gst_amount_yn === 'yes' && (
                                <td className='align-middle'>
                                  {tranx.vou_gst_amt}
                                </td>
                              )}

                              <td className='align-middle font-weight-bold text-dark'>
                                {tranx.vou_amt}
                              </td>
                              <td className='align-middle text-muted small'>
                                {tranx.vou_agst_bill}
                              </td>

                              <td className='align-middle'>
                                <Button
                                  color='outline-success'
                                  size='sm'
                                  className='px-2 py-1'
                                  disabled={isDeletingTrans}
                                  onClick={() =>
                                    gotoEditModeVoucherTranxDetail(
                                      tranx.id,
                                      tranx.temp_id,
                                    )
                                  }
                                >
                                  <i className='bi bi-pencil'></i>
                                </Button>
                              </td>

                              <td className='align-middle'>
                                <Button
                                  color='outline-danger'
                                  size='sm'
                                  className='px-2 py-1'
                                  disabled={isDeletingTrans}
                                  onClick={() =>
                                    DeleteVoucherTranxDetail(
                                      tranx.id,
                                      tranx.temp_id,
                                    )
                                  }
                                >
                                  {isDeletingTrans ? (
                                    <span className='spinner-border spinner-border-sm'></span>
                                  ) : (
                                    <i className='bi bi-trash'></i>
                                  )}
                                </Button>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan='11'
                              className='text-center py-5 text-muted'
                            >
                              <i
                                className='bi bi-inbox d-block mb-2'
                                style={{ fontSize: 28 }}
                              ></i>
                              <span className='small'>
                                No voucher entries added yet
                              </span>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  </CardBody>
                </div>
              )}
            </Form>
          </CardBody>

          {!editMode && (
            <div className='card-footer bg-white border-top px-4 py-3'>
              <Button
                type='button'
                color='primary'
                className='px-5 shadow-sm'
                onClick={AddVoucherMasterData}
              >
                <i className='bi bi-save mr-2'></i>
                Save &amp; Continue
              </Button>
            </div>
          )}
        </Card>
      </Col>
    </Row>
  );
};

export default AddVoucher;
